import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const workOrderColumns: GridColumnConfig[] = [
  {
    title: 'Work Order ID',
    field: 'workOrderID',
    filter: 'text',
    hide: true,
  },
  {
    title: 'Work Order #',
    field: 'workOrderNumber',
    searchable: true,
    filter: 'text',
    width: '150',
  },
  {
    title: 'Match Percentage',
    field: 'matchPercentage',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
    width: '250',
  },
  {
    title: 'Municipality Code',
    field: 'serviceMunicipalityCode',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Proposed Schedule Date',
    field: 'proposedScheduledDate',
    filter: 'text',
    searchable: true,
    editor: 'text',
    width: '200',
  },
  {
    title: 'Scheduled Date',
    field: 'scheduledDate',
    filter: 'text',
    searchable: true,
    editor: 'text',
    width: '150',
  },
  {
    title: 'Requested Reschedule Date',
    field: 'requestedRescheduledDate',
    filter: 'text',
    searchable: true,
    editor: 'text',
    width: '250',
  },
  {
    title: 'Primary Inspector',
    field: 'inspectorName',
    filter: 'text',
    searchable: true,
    editor: 'text',
    width: '200',
  },
    {
    title: 'Secondary Inspector',
    field: 'secondaryInspectorName',
    filter: 'text',
    searchable: true,
    editor: 'text',
    width: '200',
  },
   {
    title: 'Skill Sets',
    field: 'serviceSkillsets',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Equipments',
    field: 'serviceEquipments',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Jobsite',
    field: 'jobsite',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Builder Job Number',
    field: 'jobNumber',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    searchable: true,
    width: '250',
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    searchable: true,
    width: '250',
  },
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    searchable: true,
    width: '250',
  },
  {
    title: 'Project Code',
    field: 'projectCode',
    filter: 'text',
    searchable: true,
    width: '150',
  },

  {
    title: 'Billing Type',
    field: 'billingType',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Cut-off Time',
    field: 'cutOffTime',
    filter: 'text',
    searchable: true,
    width: '120',
  },
  {
    title: 'Square Feet',
    field: 'squareFeet',
    filter: 'text',
    searchable: true,
    width: '120',
  },
  {
    title: 'City',
    field: 'city',
    filter: 'text',
    searchable: true,
    width: '120',
  },
  {
    title: 'Zip',
    field: 'zip',
    filter: 'text',
    searchable: true,
    width: '120',
  },
  {
    title: 'Permit Number',
    field: 'permitNumber',
    filter: 'text',
    searchable: true,
    width: '160',
  },
  {
    title: 'Project Department',
    field: 'projectDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Lot Department',
    field: 'unitDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: ' ',
    field: 'warning',
    filter: 'text',
    searchable: false,
    width: '60px',
  },
];
